export default {
  unitLabel: {
    carbonNitrogen: 'Uhlík / Dusík',
    thickness: 'Hrúbka',
  },
};
